"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
class UrlHelper {
    static getWebClientUrl(params) {
        // Websubdomain allow us to try out the integration with different version of webshell
        // Current up to date list is available: candidate, preview, dev, alpha, beta
        const { webSubDomain } = UrlHelper.getQueryParameters();
        return config_1.default.urls.app.s4lWeb(params, webSubDomain);
    }
    static getQueryParameters() {
        if (!location.search || location.search.length < 1) {
            return {};
        }
        return location.search
            .substr(1)
            .split('&')
            .map((value) => {
            const split = value.split('=');
            return {
                key: decodeURIComponent(split[0]),
                value: decodeURIComponent(split[1] || ''),
            };
        })
            .reduce((prev, current) => {
            if (!!prev[current.key]) {
                const prevValue = prev[current.key];
                if (typeof prevValue === 'string') {
                    prev[current.key] = [prev[current.key]];
                }
                prev[current.key].push(current.value);
            }
            else {
                prev[current.key] = current.value;
            }
            return prev;
        }, {});
    }
    static getQueryParameter(key) {
        return UrlHelper.getQueryParameters()[key];
    }
}
exports.UrlHelper = UrlHelper;
